import React, { useState } from 'react'
import styled from 'styled-components'
import IconButton from '@/v2/components/common/IconButton'
import Slider from '@mui/material/Slider'
import useDetectDevice from '@/v2/hooks/useDetectDevice'

const Wrapper = styled.div`
  display: inline-flex;
  width: ${({ $show, $isMobile }) =>
    $show ? ($isMobile ? '186px' : '200px') : $isMobile ? '42px' : '32px'};
  transition: 0.3s;
  padding-right: 10px;
`

const SliderButton = ({
  title,
  icon,
  value,
  min = 0,
  max = 180,
  step = 1,
  onClick,
  onChange,
  valueLabelDisplay = 'auto',
}) => {
  const { isMobile } = useDetectDevice()
  const [show, setShow] = useState(false)
  const handleChange = (_e, newValue) => {
    onChange(newValue)
  }

  return (
    <Wrapper
      $show={show}
      $isMobile={isMobile ? 1 : 0}
      onMouseEnter={() => !isMobile && setShow(true)}
      onMouseLeave={() => !isMobile && setShow(false)}
    >
      <IconButton
        title={title}
        onClick={() => {
          onClick()
          if (isMobile) {
            setShow(!show)
          }
        }}
      >
        {icon}
      </IconButton>
      {show && (
        <Slider
          size="small"
          step={step}
          value={value}
          valueLabelDisplay={valueLabelDisplay}
          color="secondary"
          min={min}
          max={max}
          sx={{
            ml: '15px',
            '& .MuiSlider-track': {
              border: 0,
              backgroundColor: 'currentColor',
            },
            '& .MuiSlider-rail': {
              opacity: 0.5,
              backgroundColor: 'rgba(0, 0, 0, 0.26)',
            },
            '& .MuiSlider-thumb': {
              backgroundColor: 'currentColor',
            },
          }}
          onChange={handleChange}
        />
      )}
    </Wrapper>
  )
}

export default SliderButton
